// extracted by mini-css-extract-plugin
export default {"controlButton":"aLOLySzn_TgvH5GGgQUc","icon":"Sz0c7hpEdvFDV_cK5sCT","reverse":"RLmCPzK7TQDeLyZVVvJk"};